export const initState = {
	type: null,
};

export default initState;
